export default __webpack_public_path__ + "static/media/check-white-icon.35081603.svg";